import React, { useEffect, useState } from 'react';
import '../styles/kofiNudge.css';

const STORAGE_KEY = 'visitCount';
const STORAGE_DATE_KEY = 'visitLastDate';
const FIRST_TRIGGER = 5;
const REPEAT_EVERY = 10;

const KofiNudge = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const today = new Date().toDateString();
    const lastDate = localStorage.getItem(STORAGE_DATE_KEY);
    const count = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);

    if (lastDate === today) return;

    const newCount = count + 1;
    localStorage.setItem(STORAGE_KEY, newCount);
    localStorage.setItem(STORAGE_DATE_KEY, today);

    const shouldShow = newCount === FIRST_TRIGGER || (newCount > FIRST_TRIGGER && (newCount - FIRST_TRIGGER) % REPEAT_EVERY === 0);

    if (shouldShow) {
      const timer = setTimeout(() => setVisible(true), 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  if (!visible) return null;

  return (
    <div className='kofiNudge show'>
      <button className='kofiNudgeClose' onClick={() => setVisible(false)}>×</button>
      <div className='kofiNudgeIcon'>☕</div>
      <p className='kofiNudgeTitle'>Pray the Dice vous plaît ?</p>
      <p className='kofiNudgeText'>Si vous aimez l'application, vous pouvez soutenir son développement sur Ko-fi !</p>
      <a
        className='kofiNudgeBtn'
        href="https://ko-fi.com/praythedice"
        target="_blank"
        rel="noreferrer"
        onClick={() => setVisible(false)}
      >
        Soutenir sur Ko-fi
      </a>
    </div>
  );
};

export default KofiNudge;
